module.exports = __webpack_public_path__ + "fd5a608a/img/18000000-9.cec28bce.png";